module.exports = __webpack_public_path__ + "img/20191113161014588.ef80827b.jpg";